import React from 'react';

function Rocket45({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        d="M9.551 10.285c-1.305.148-3.423.38-6.353.695a.967.967 0 0 0-.683.969c.01.456.288.93.731 1.246l10.625 7.44c.448.308.99.407 1.421.26a.967.967 0 0 0 .677-.973c-.675-2.756-1.18-4.824-1.513-6.202"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15.25 12.59c1.251-1.788 2.238-3.63 1.982-6.056-.025-.232-.037-.662-.643-1.087-.511-.358-.939-.232-1.23-.185-2.34.378-3.777 2.104-5.024 3.886l-.495.707-3.739 5.34 1.567 1.096 1.607 1.125 1.741 1.22 3.739-5.34.494-.706z" />
      <path d="M9.706 15.277L7.41 18.553" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.024 9.665l.82.574" strokeLinecap="square" />
    </svg>
  );
}

export default Rocket45;
